export interface ISelectProps {
  children: React.ReactNode;
}

const Selectd = ({ children }: ISelectProps) => {
  return <div>{children}</div>;
};

export default Selectd;
